import React, { useState, useEffect } from 'react'

import { Link } from 'gatsby'
import { Tab, Tabs } from 'react-bootstrap'
import Health from './Health'
import OA from './OA'
import Img from "gatsby-image"

const POC = (props) => {
    const { data } = props
    return (
        <div className="row mt-2">
            {data.map((el, i) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={i}>
                    <Link to={`${el.node.frontmatter.path}`}
                        className="link primary" >
                        {
                            el.node.frontmatter.featuredImage ? (
                                <Img fluid={el.node.frontmatter.featuredImage.childImageSharp.fluid} alt={el.node.frontmatter.title} className="mb-1" />

                            )
                                :
                                (
                                    <p>{el.node.frontmatter.title}</p>
                                )
                        }
                    </Link>
                </div>
            ))
            }
        </div>
    )
}
const SM = (props) => {
    const { data } = props
    return (
        <div className="row mt-2">
            {data.map((el, i) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={i}>
                    <Link to={`${el.node.frontmatter.path}`}
                        className="link primary"
                    >
                        {
                            el.node.frontmatter.featuredImage ? (
                                <Img fluid={el.node.frontmatter.featuredImage.childImageSharp.fluid} alt={el.node.frontmatter.title} className="mb-2" />

                            )
                                :
                                (
                                    <p>{el.node.frontmatter.title}</p>
                                )
                        }
                    </Link>
                </div>
            ))
            }
        </div>
    )
}

const CategoryTabs = props => {

    useEffect(() => {
        const getLSKey = () => {
            localStorage.getItem('tabKey') ? setKey(localStorage.getItem('tabKey')) : setKey('socialMedia')
        }
        getLSKey()
    }, [])

    const [key, setKey] = useState("")
    const { projects } = props
    const smArray = projects.filter(el => el.node.frontmatter.category === 'sm')
    const paoArray = projects.filter(el => el.node.frontmatter.category === 'pao')

    const storeSelection = (key) => {
        localStorage.setItem('tabKey', key)
        setKey(key)
    }

    return (
        <section className="tabs">
            <h1 className="pf display-4"><strong>Projetos</strong></h1>

            <p>Navegue pelas categorias e descubra mais sobre cada projeto.</p>

            <div className="col">
                <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => storeSelection(k)}
                >
                    <Tab eventKey="socialMedia" title="Social Media">
                        <SM data={smArray} />
                    </Tab>
                    <Tab eventKey="petsAndOthers" title="Pets & Outros">
                        <POC data={paoArray} />
                    </Tab>
                    <Tab eventKey="health" title="Health & Cosméticos">
                        <Health />
                    </Tab>
                    <Tab eventKey="otherArts" title="Outras Artes">
                        <OA />
                    </Tab>
                </Tabs>
            </div>
        </section>
    )
}

export default CategoryTabs
